// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__stWYV","list":"styles_list__10Z-5"};